import { createResource, createSignal } from 'solid-js'
import { whenDeleting } from '../Messages/whenDeleting'

// Custom hook to manage messages, particularly deleting them
export function useDelete() {
	// Signal to hold the ID of the message currently being deleted
	const [deletingId, setDeletingId] = createSignal<string | null>(null)

	// Resource to handle deleting a message from the Supabase database
	const [deletingResource] = createResource(deletingId, whenDeleting)

	return {
		// Set this with a message ID to trigger deletion
		deletingResource,
		setDeletingId,
		deletingId,
	}
}
